import { render, staticRenderFns } from "./albumAudios.vue?vue&type=template&id=31c63fb3&scoped=true&"
import script from "./albumAudios.vue?vue&type=script&lang=ts&"
export * from "./albumAudios.vue?vue&type=script&lang=ts&"
import style0 from "./albumAudios.vue?vue&type=style&index=0&id=31c63fb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c63fb3",
  null
  
)

export default component.exports